export default __webpack_public_path__ + "static/media/Guru-Parampara-25.4a67ad5d.png";